import { Injectable } from '@angular/core';
import { RequestMethod, SgWebHttpClient } from '@ds/ng-wt-helpers/http';
import { ACCOUNT_UNLOCK_GENERATE_OTP, ACCOUNT_UNLOCK_VALIDATE_OTP, EXISTING_PLAYER_REGISTARTION, GET_COGNITO_DETAILS, GET_COGNITO_USER_INFO, MFA_RESET_GENERATE_OTP, MFA_RESET_VALIDATE_OTP, PLAYER_REGISTARTION, UPDATE_MIGRATION_STATUS, VALIDATE_PLAYER_PIN, VALIDATE_TOTP, VALIDATE_USER_INFO } from '../constants/login.constants';
import { AuthService } from '../../authentication/auth.service';
import { LoginDetailsService } from 'src/app/core/login/services/login-details.service';
import { AwsClient } from 'aws4fetch';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  appConfigurations = window['config'];
  playerid: any;
  playerpin: any;
  private awsClient: AwsClient;
  
  constructor(private http: SgWebHttpClient,
    public authService: AuthService,
    private loginDetailsService: LoginDetailsService) { }

  getPlayerId(playerId) {
    this.playerid = playerId
  }
  getPlayerPin(playerpin) {
    this.playerpin = playerpin
  }
  submitForm(payload: any) {
    const token = this.authService.getAuthToken('idToken'); // Fetch the token
    const headers = {
      'Authorization': `Bearer ${token}`, // Ensure the token is correctly passed
      'Content-Type': 'application/json'
    };
    return this.http.restAPIAsync(
      RequestMethod.POST,
      PLAYER_REGISTARTION(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode),
      {
        body: payload,
        headers: headers
      }
    );
  }
  existingPlayer(payload) {
    return this.http.restAPIAsync(
      RequestMethod.POST,
      EXISTING_PLAYER_REGISTARTION(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode, this.playerid),
      {
        body: payload,
        headers: { 'X-TimeZone': Intl.DateTimeFormat().resolvedOptions().timeZone }
      }
    );
  }

  validateTOtp(payload) {
    return this.http.restAPIAsync(
      RequestMethod.POST,
      VALIDATE_TOTP
        (this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode), {
      body: payload,
    }
    );
  }

  validatePin(payload) {
    const data = {
      data: this.playerpin
    }
    return this.http.restAPIAsync(
      RequestMethod.POST,
      VALIDATE_PLAYER_PIN(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode, this.playerid),
      {
        body: payload,


      }
    )
  }

  getCognitoDetails(accountNumber: string) {
    return this.http.restAPIAsync(
      RequestMethod.GET,
      GET_COGNITO_DETAILS(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode),
      {
        body: {
          searchParameter: accountNumber
        }
      }
    );
  }

  async getCognitoUserInfo(searchValue: string) {
    // Initialize AWS client with credentials
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({ 
      accessKeyId: awsConfigs.AccessKey, 
      secretAccessKey: awsConfigs.SecretKey, 
      region: awsConfigs.region, 
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    const url = GET_COGNITO_USER_INFO(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode, searchValue);
    
    return this.awsClient.fetch(url, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'accept': 'application/vnd.playerinfo.api+json; version=1.0'
      }
    }).then(async res => {
      if (!res.ok) {
        throw new Error(`getCognitoUserInfo request failed with status ${res.status}`);
      }
      return res.json();
    });
  }

  async validateUserInfo(payload: { dob: string; pincode: string; accountNumber: string }) {
    // Initialize AWS client with credentials
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({ 
      accessKeyId: awsConfigs.AccessKey, 
      secretAccessKey: awsConfigs.SecretKey, 
      region: awsConfigs.region, 
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    const url = VALIDATE_USER_INFO(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode);
    
    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'accept': 'application/vnd.playerinfo.api+json; version=1.0'
      },
      body: JSON.stringify(payload)
    }).then(async res => {
      return res.json();
    });
  }

  async generateUnlockOtp(identifier: string, isEmail: boolean, lang: string = 'en') {
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({
      accessKeyId: awsConfigs.AccessKey,
      secretAccessKey: awsConfigs.SecretKey,
      region: awsConfigs.region,
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    const url = ACCOUNT_UNLOCK_GENERATE_OTP(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode, identifier, isEmail);

    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-TimeZone': Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }).then(async res => {
      return res.json();
    });
  }

  async validateUnlockOtp(otp: string, identifier: string, isEmail: boolean) {
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({
      accessKeyId: awsConfigs.AccessKey,
      secretAccessKey: awsConfigs.SecretKey,
      region: awsConfigs.region,
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    const url = ACCOUNT_UNLOCK_VALIDATE_OTP(this.loginDetailsService.baseUrl, this.appConfigurations.tenantCode, identifier, isEmail);
    
    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({ otp })
    }).then(async res => {
      if (!res.ok) {
        const errorBody = await res.json().catch(() => ({}));
        throw { error: errorBody, status: res.status };
      }
      return res;
    });
  }

  async generateMfaResetOtp(emailAddress: string, accountNumber?: string) {
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({
      accessKeyId: awsConfigs.AccessKey,
      secretAccessKey: awsConfigs.SecretKey,
      region: awsConfigs.region,
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });
    
    // Determine if using email or account number
    const isEmail = !!emailAddress && !accountNumber;
    const identifier = isEmail ? emailAddress : accountNumber!;

    // Build URL with query parameters
    const url = MFA_RESET_GENERATE_OTP(
      this.loginDetailsService.baseUrl,
      this.appConfigurations.tenantCode,
      identifier,
      isEmail
    );

    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-TimeZone': Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }).then(async res => {
      return res.json();
    });
  }

  async validateMfaResetOtp(otp: string, identifier: string, isEmail: boolean) {
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({
      accessKeyId: awsConfigs.AccessKey,
      secretAccessKey: awsConfigs.SecretKey,
      region: awsConfigs.region,
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    // Build URL with query parameters
    const url = MFA_RESET_VALIDATE_OTP(
      this.loginDetailsService.baseUrl,
      this.appConfigurations.tenantCode,
      identifier,
      isEmail
    );
    
    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ otp })
    }).then(async res => {
      if (res.status !== 200) {
        const errorText = await res.text().catch(() => '');
        throw { error: { message: errorText || 'OTP validation failed' } };
      }
      return res.text();
    });
  }

  async updateMigrationStatus(payload: { searchValue: string; isMigrationCompleted: boolean }) {
    const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
    if (!awsConfigs) {
      throw new Error('AWS credentials unavailable');
    }
    this.awsClient = new AwsClient({
      accessKeyId: awsConfigs.AccessKey,
      secretAccessKey: awsConfigs.SecretKey,
      region: awsConfigs.region,
      sessionToken: awsConfigs.sessionToken,
      retries: 0
    });

    const url = UPDATE_MIGRATION_STATUS(
      this.loginDetailsService.baseUrl,
      this.appConfigurations.tenantCode
    );
    
    return this.awsClient.fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'accept': 'application/vnd.playerinfo.api+json; version=1.0'
      },
      body: JSON.stringify(payload)
    }).then(async res => {
      if (!res.ok) {
        const errorText = await res.text().catch(() => '');
        throw { error: { message: errorText || 'Migration status update failed' } };
      }
      return res.json();
    });
  }
}
